import { DefaultRequest } from 'scripts/api';

/* Model */
class RouteEquipmentAssignmentModel extends App.Models.AssignUnassignToRoute {
  modelUrl = "RouteEquipmentAssignment";
  urlAssignUnassign = "RouteEquipment";

  assignToRoute = (options, successCallback, errorCallback) => {
    var error = null,
      listEquipment = options.routeEquipments;

    var routeId = options.routeEquipments[0].route.id;

    if (listEquipment) {
      try {
        const request = new DefaultRequest({
          url: "RouteEquipment/batch",
          method: "post",
          data: listEquipment,
          success: function(data) {
            if (successCallback) {
              successCallback(data);
            }
            App.Objects.RouteDetails.updateRouteModel(routeId);
          },
          error: function(data) {
            if (errorCallback) {
              errorCallback(data);
            }

            var mMessage = new Monet.Form.Messages.AlertMessage();
            mMessage.setMessage(JSON.parse(data.responseText));
            mMessage.triggerMessage();
          }
        });
        request.send();
      } catch (e) {
        error = new Monet.Exception.ReturnError(
          this,
          "No save equipment to route.",
          e
        );
        error.console();
      }
    } else {
      error = new Monet.Exception.ReturnError(this, "No data to save drive.");
      error.console();
    }
  };

  unassignToRoute = (options, successCallback, errorCallback) => {
    var removed = false,
      errors = null,
      assignmentId = options.assignmentId;

    try {
      const request = new DefaultRequest({
        url: "RouteEquipment/" + assignmentId,
        method: "delete",
        success: function(data) {
          removed = data;

          if (successCallback) {
            successCallback(data);
          }
          if (options.routeId) {
            App.Objects.RouteDetails.updateRouteModel(options.routeId);
          }
        },
        error: function(data) {
          if (errorCallback) {
            errorCallback(data);
          }

          var mMessage = new Monet.Form.Messages.AlertMessage();
          mMessage.setMessage(JSON.parse(data.responseText));
          mMessage.triggerMessage();
        }
      });
      request.send();
    } catch (e) {
      errors = new Monet.Exception.ReturnError(this, "No unassign drive.", e);
      errors.console();
    }

    return removed;
  };

  unassignAllToRoute = (options, successCallback, errorCallback) => {
    const assignmentsListId = options.assignmentsListId;

    try {
        const request = new DefaultRequest({
            url: 'RouteEquipment/BatchDelete',
            method: 'post',
            data: assignmentsListId,
            success: function (data) {
                if (successCallback) {
                    successCallback(data);
                }
            },
            error: function (data) {
                if (errorCallback) {
                    errorCallback(data);
                }

                var mMessage = new Monet.Form.Messages.AlertMessage();
                mMessage.setMessage(JSON.parse(data.responseText));
                mMessage.triggerMessage();
            }
        });
        request.send();

    } catch (e) {
        error = new Monet.Exception.ReturnError(this,
            "No unassign drive.", e);
        error.console();

        errorCallback();
    }
  }
}

App.Models.RouteEquipmentAssignment = RouteEquipmentAssignmentModel;

/* Collection */
class RouteEquipmentAssignmentCollection extends App.Collections
  .BaseCollection {
  url = "RouteEquipmentAssignment";
  model = App.Models.RouteEquipmentAssignment;
}

App.Collections.RouteEquipmentAssignments = RouteEquipmentAssignmentCollection;

/* Router */
class RouteEquipmentAssignmentRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteEquipmentAssignment";
    const model = App.Models.RouteEquipmentAssignment;
    const collectionClass = App.Collections.RouteEquipmentAssignments;

    super(entityName, model, collectionClass);
  }
}

App.Routers.RouteEquipmentAssignment = RouteEquipmentAssignmentRouter;
